import DOMPurify from 'dompurify';

/**
 * Default allowlist — mirrors the config used by
 * `src/components/liveReport/reportBuilder2/widgets/ParagraphWidget.jsx`.
 * Covers the tags TinyMCE/AI output produces (paragraphs, basic formatting,
 * links, lists) and nothing that can execute script.
 */
export const DEFAULT_ALLOWED_TAGS = ['p', 'b', 'i', 'em', 'strong', 'a', 'ol', 'ul', 'li', 'br'];
export const DEFAULT_ALLOWED_ATTR = ['href', 'target', 'rel'];

/**
 * @typedef {object} SanitizeOptions
 * @property {string[]} [allowedTags] - Tags to keep (defaults to DEFAULT_ALLOWED_TAGS)
 * @property {string[]} [allowedAttr] - Attributes to keep (defaults to DEFAULT_ALLOWED_ATTR)
 */

/**
 * Sanitize an HTML string before it is passed to `dangerouslySetInnerHTML`.
 *
 * Use this at EVERY `dangerouslySetInnerHTML` site that renders stored or
 * user/AI-supplied content, so a payload like `<img src=x onerror=...>` can
 * never execute. One shared config keeps every site consistent.
 *
 * @param {string | null | undefined} dirty - The untrusted HTML string
 * @param {SanitizeOptions} [options] - Optional per-site allowlist overrides
 * @returns {string} Sanitized HTML safe to inject
 */
const sanitizeHtml = (dirty, options = {}) => {
    if (dirty == null) return '';

    return DOMPurify.sanitize(String(dirty), {
        ALLOWED_TAGS: options.allowedTags || DEFAULT_ALLOWED_TAGS,
        ALLOWED_ATTR: options.allowedAttr || DEFAULT_ALLOWED_ATTR,
    });
};

export default sanitizeHtml;
